<template lang="pug">
el-dialog(
  :title="title",
  width="95%",
  :visible.sync="visible",
  :modal-append-to-body="false",
  :append-to-body="true"
)
  el-form(
    :model="ruleForm",
    :inline="false",
    :rules="rules",
    ref="ruleForm",
    label-width="130px"
  )
    el-card(shadow="never")
      div
        el-form-item(label="比赛ID:", prop="matchId")
          font {{ ruleForm.matchId }}
        el-form-item(label="比赛名称:", prop="matchName")
          font {{ ruleForm.matchName }}
        el-form-item(label="主办方:", prop="orgName")
          font {{ ruleForm.orgName }}
        el-form-item(label="主办城市:", prop="cityName")
          font {{ ruleForm.provinceName }}&nbsp;{{ ruleForm.cityName }}
        el-form-item(label="比赛场地:", prop="placeName")
          font {{ ruleForm.placeName }} &nbsp;&nbsp;&nbsp;地址: {{ ruleForm.venueAddress }}
        el-form-item(label="比赛类型:", prop="ctType")
          //- font(v-if="ruleForm.ctType === 5") 月度赛-资格赛
          //- font(v-if="ruleForm.ctType === 6") 月度赛-级别赛
          //- 全局搜索,替换
          font(v-if="ruleForm.ctType === 5") 挑战赛
          font(v-if="ruleForm.ctType === 6") 群英赛
          font(v-if="ruleForm.ctType === 4") 年度总决赛
        el-form-item(label="胜负判定方式:", prop="outcomeType")
          font(v-if="ruleForm.outcomeType === 0") 胜场制
          font(v-if="ruleForm.outcomeType === 1") 积分制
        el-form-item(label="积分配置:", prop="ifDoublePoint")
          font(v-if="ruleForm.ifDoublePoint === 0") 单倍积分
          font(v-if="ruleForm.ifDoublePoint === 1") 双倍积分
        el-form-item(label="签位:", prop="applySize")
          font {{ ruleForm.applySize }}
        //- 添加无赛中模式
        el-form-item(label="赛中管理模式:", prop="inGameManagementMode")
          font(v-if="ruleForm.inGameManagementMode == 1") 赛中管理
          font(v-if="ruleForm.inGameManagementMode == 0") 无赛中管理
        el-form-item(label="积分起始点:", prop="startScore")
          font {{ ruleForm.startScore }}
        el-form-item(label="冠军加分:", prop="championAddPoints")
          font {{ ruleForm.championAddPoints }}
        el-form-item(label="个人参与积分:")
          font(v-if="ruleForm.personPointsRules == 1") 参与
          font(v-if="ruleForm.personPointsRules == 0") 不参与
          span(style="font-size: 14px; font-weight: 600; margin-left: 30px;") 计算规则：
          span(style="font-size: 14px; margin-left: 20px;") 胜利： {{ ruleForm.personWinPoints }}
          span(style="font-size: 14px; margin-left: 20px;") 失败： {{ ruleForm.personFailPoints }}
          span(style="font-size: 14px; margin-left: 20px;") 弃权： {{ ruleForm.personAbandonPoints }}
        el-form-item(label="俱乐部参与积分:")
          font(v-if="ruleForm.clubPointsRules == 1") 参与
          font(v-if="ruleForm.clubPointsRules == 0") 不参与
          span(style="font-size: 14px; font-weight: 600; margin-left: 30px;") 计算规则：
          span(style="font-size: 14px; margin-left: 20px;") 胜利： {{ ruleForm.clubWinPoints }}
          span(style="font-size: 14px; margin-left: 20px;") 失败： {{ ruleForm.clubFailPoints }}
          span(style="font-size: 14px; margin-left: 20px;") 弃权： {{ ruleForm.clubAbandonPoints }}
        el-form-item(label="是否第六人:")
          font(v-if="ruleForm.competitionClub.sixthMan == 1") 是
          font(v-if="ruleForm.competitionClub.sixthMan == 0") 否
        el-form-item(label="联系电话:", prop="contactMobile")
          font {{ ruleForm.contactMobile || '--' }}
        el-form-item(label="是否首页推荐:")
          font(v-if="ruleForm.recommend == 1") 是
          font(v-if="ruleForm.recommend == 0") 否
        el-form-item(label="报名时间:", prop="applyDate")
          font {{ ruleForm.matchSignStartTime }}&nbsp;至&nbsp;{{ ruleForm.matchSignEndTime }}
        el-form-item(label="调整报名名单时间:", prop="applySize")
          font {{ ruleForm.competitionClub.adjustAppearListStartTime }} 至 {{ ruleForm.competitionClub.adjustAppearListEndTime }}
        el-form-item(
          label="调整出场名单时间:",
          prop="applySize",
          v-if="ruleForm.inGameManagementMode == 1"
        )
          font {{ ruleForm.competitionClub.adjustEnrollListStartTime }} 至 {{ ruleForm.competitionClub.adjustEnrollListEndTime }}
        el-form-item(label="比赛时间:", prop="matchStartTime")
          font {{ ruleForm.matchStartTime }}
        el-form-item(label="列表页图:", prop="imgList")
          <img :src="listImageUrl" :onerror="defaultImg" style="width:256px;height:190px"/>
        el-form-item(label="详情页图:", prop="imgDetailList")
          <img :src="detailImageUrl" :onerror="defaultImg" style="width:750px;height:310px"/>
        el-form-item(label="比赛简介:", prop="matchDescription")
          div(v-html="ruleForm.matchDescription")
        el-form-item(label="报名须知:", prop="gameDescription")
          font {{ ruleForm.gameDescription }}
        el-form-item(label="比赛规程:", prop="gameDescription")
          <div v-for="(item,index) in pdfs" style="display:flex">
            <div style="width:600px"> {{item.fileName}}</div>
            <a :href="item.url" target="_blank" style="text-decoration: none"> 下载</a>
          </div>
    br
    el-card(shadow="never")
      div(slot="header")
        font(style="font-weight: bold; font-size: 18px") 报名限定
      div
        el-form-item(label="报名限定:", prop="presidentLimit")
          font(v-if="ruleForm.presidentLimit === 1") 不限
          font(v-if="ruleForm.presidentLimit === 0") 限会长
        el-form-item(label="队伍人数:")
          font {{ ruleForm.teamMin }}-{{ ruleForm.teamMax }} 人
        el-form-item(label="俱乐部等级:")
          font(v-for="(item, index) in ruleForm.clubLimit", :key="index") {{ item == 1 ? "甲A" : item == 2 ? "甲B" : item == 3 ? "乙A" : item == 4 ? "乙B" : item == 5 ? "丙A" : item == 6 ? "丙B" : item == 7 ? "丁A" : item == 8 ? "丁B" : item == 9 ? "资格甲" : item == 10 ? "资格乙" : item == 11 ? "资格丙" : item == 12 ? "资格丁" : "" }}&nbsp;&nbsp;&nbsp;
        div(style="margin: -20px 0 10px 56px; display: flex; align-items: center;")
          div(style="margin-right: 12px; color: #606266;") 赛制配置:
          div(style="padding: 10px 20px 20px; border: 1px solid #CDCDCD;")
            el-tabs(v-model="competitionRulesTab")
              el-tab-pane(v-for="(item, index) in competitionRules" :keys="index" :label="item.groupName" :name="item.groupCode.toString()")
                div
                  div(style="display: flex; align-items: center;")
                    div(style="display: flex;")
                      div(style="margin-left: 28px;") 级别别名：
                      div(style="width: 100px; overflow: hidden;") {{ item.groupNickname || '--' }}
                    div(style="margin-left: 20px; display: flex;")
                      div 级别队伍数：
                      div {{ item.teamNum || '--' }}
                  div(v-if="ruleForm.inGameManagementMode == 1" style="margin-top: 10px; display: flex; align-items: center;")
                    div(style="display: flex;")
                      div 第一阶段赛制：
                      div(style="width: 100px; overflow: hidden;") {{ firstCompetitionRuleList[item.FirstCompetition] || '--' }}
                    div(style="margin-left: 20px; display: flex;")
                      div(style="margin-left: 42px;") 组数：
                      div(style="width: 100px; overflow: hidden;") {{ item.groupNum || '--' }}
                    div(style="margin-left: 50px; display: flex;")
                      div 第一阶段附加规则：
                      div(style="width: 100px; overflow: hidden;") {{ firstCompetitionRulePlusList[item.allowPlayOff] || '--' }}
                    div(style="margin-left: 50px; display: flex;")
                      div 小组晋级人数：
                      div(style="width: 100px; overflow: hidden;") {{ item.groupRiseNum || '--' }}
                  div(v-if="ruleForm.inGameManagementMode == 1" style="margin-top: 10px; display: flex; align-items: center;")
                    div(style="display: flex;")
                      div 第二阶段赛制：
                      div(style="width: 100px; overflow: hidden;") {{ secondCompetitionRuleList[item.SecondCompetition] || '--' }}
                    div(style="margin-left: 20px; display: flex;")
                      div(style="margin-left: 28px;") 交叉数：
                      div(style="width: 100px; overflow: hidden;") {{ crossNumList[item.crossNum] || '--' }}
                    div(style="margin-left: 50px; display: flex;")
                      div 第二阶段附加规则：
                      div {{ firstCompetitionRulePlusList[item.allowPlayOff1] || '--' }}
        el-form-item(label="重复报名:", prop="repeatSign")
          font(v-if="ruleForm.repeatSign === 1") 允许
          font(v-if="ruleForm.repeatSign === 0") 不允许
        el-form-item(label="性别限定:", prop="genderLimit")
          font(v-if="ruleForm.genderLimit === 2") 不限
          font(v-if="ruleForm.genderLimit === 1") 男
          font(v-if="ruleForm.genderLimit === 0") 女
        el-form-item(label="年龄限定:")
          div(v-if="ruleForm.genderLimit === 2")
            font(v-if="!ruleForm.ageMinMen && !ruleForm.ageMaxMen") 不限
            font(v-if="!(!ruleForm.ageMinMen && !ruleForm.ageMaxMen)") 男选手&nbsp;{{ ruleForm.ageMinMen }}-{{ ruleForm.ageMaxMen }}岁
            font(v-if="!(!ruleForm.ageMinWomen && !ruleForm.ageMaxWomen)") &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;女选手&nbsp;{{ ruleForm.ageMinWomen }}-{{ ruleForm.ageMaxWomen }}岁
          div(v-if="ruleForm.genderLimit === 1")
            font &nbsp;男选手&nbsp;{{ ruleForm.ageMinMen }}-{{ ruleForm.ageMaxMen }}岁
          div(v-if="ruleForm.genderLimit === 0")
            font &nbsp;女选手&nbsp;{{ ruleForm.ageMinWomen }}-{{ ruleForm.ageMaxWomen }}岁
        el-form-item(label="年度积分≥", prop="scoreMin")
          font {{ ruleForm.scoreMin }}
    br
    el-card(shadow="never")
      div(slot="header")
        font(style="font-weight: bold; font-size: 18px") 报名费用
      div
        el-table(:data="tableData", border)
          el-table-column(prop="dataName", label="角色", align="center")
          el-table-column(prop="type", label="报名费用", align="center")
            template(slot-scope="scope")
              font ￥&nbsp;{{ scope.row.price }}元
    br
    el-card(shadow="never")
      div(slot="header")
        font(style="font-weight: bold; font-size: 18px") 退款设置
      div
        el-table(:data="ruleForm.ctRefundList", border)
          el-table-column(
            prop="index",
            label="序号",
            align="center",
            width="100"
          )
          el-table-column(
            prop="minDuration",
            label="距比赛开始时间/小时（含）",
            align="center"
          )
          el-table-column(prop="refundScale", label="退款比例/%", align="center")
    br
    el-card(shadow="never")
      div(slot="header")
        font(style="font-weight: bold; font-size: 18px") 电子证书设置
      div
        el-form-item.comecs(label="电子证书图:", prop="imgList")
          .infocont(v-for="(item, index) in ruleForm.ecertList")
            <img  :src="item.imgUrl" :onerror="defaultImg" style="width:240px;height:174px"/>
            span {{ item.rewardLevel == 1 ? "一等奖" : item.rewardLevel == 2 ? "二等奖" : item.rewardLevel == 3 ? "三等奖" : item.rewardLevel == 4 ? "四等奖" : "" }}

    br
    el-card(shadow="never", v-if="type == 'release'")
      div(slot="header")
        font(style="font-weight: bold; font-size: 18px") 审核意见
      div
        el-form-item(prop="verifyReason", label="填写审核意见:")
          el-input(
            v-model="ruleForm.verifyReason",
            type="textarea",
            :rows=5,
            resize="none"
          )

  span.dialog-footer(slot="footer", v-if="!type")
    el-button(@click="visible = false") 返 回
  //审核发布
  span.dialog-footer(slot="footer", v-if="type == 'release'")
    el-button(@click="releaseSubmit(2)", type="primary" :disabled="btnLoading") 发 布
    el-button(@click="releaseSubmit(5)", type="danger" :disabled="btnLoading") 拒 绝
    el-button(@click="visible = false") 取 消
  //- //支付弹窗组件
  zfpage(
    :openfree="visibleFee",
    :record="record",
    v-if="visibleFee",
    @zfsuccess="zfsuccess"
  )
</template>
<script>
import zfpage from "../zfpage.vue";
export default {
  components: {
    zfpage,
  },
  data() {
    return {
      pdfs: [],
      visibleFee: false,
      record: {},
      type: "",
      title: "查看详情",
      btnLoading: false,
      tableData: [
        {
          dataName: "团队费用",
          price: 0.0,
        },
      ],
      defaultImg: "",
      listImageUrl: "",
      detailImageUrl: "",
      ruleForm: {
        id: null,
        ctId: "",
        matchName: "",
        orgId: "",
        city: "",
        province: "",
        placeId: "",
        ctType: "",
        applySize: "",
        applyDate: [],
        matchSignStartTime: "",
        matchSignEndTime: "",
        matchStartTime: "",
        imgList: "",
        presidentLimit: "",
        teamMin: "",
        teamMax: "",
        gameDescription: "",
        matchDescription: "",
        imgDetailList: "",
        repeatSign: "0",
        genderLimit: "2",
        ageLimit: "",
        ageMinMen: undefined,
        ageMaxMen: undefined,
        ageMinWomen: undefined,
        ageMaxWomen: undefined,
        scoreMin: "",
        ctRefundList: [],
        byx1: "",
        verifyReason: "",
        competitionClub: {
          sixthMan: "",
        },
      },
      visible: false,
      rules: {
        // verifyReason: [
        //     { required: true, message: '审核意见不能为空!', trigger: 'blur' },
        //     { max: 200, message: '审核意见长度不能超过200个字符!' }
        // ]
      },
      competitionRulesTab: '',
      competitionRulesTabList: {
        '1': '甲A',
        '2': '甲B',
        '3': '乙A',
        '4': '乙B',
        '5': '丙A',
        '6': '丙B',
        '7': '丁A',
        '8': '丁B',
        '9': '资格甲',
        '10': '资格乙',
        '11': '资格丙',
        '12': '资格丁'
      },
      competitionRules: [],
      firstCompetitionRuleList: {
        0: '淘汰附加赛',
        1: '小组循环赛',
        5: '淘汰赛',
				7: '俱乐部队队碰赛'
      },
      firstCompetitionRulePlusList: {
        1: '第三四名争夺季军',
        0: '无附加赛',
      },
      secondCompetitionRuleList: {
        2: '同名次小组循环赛',
        3: '同名次淘汰附加赛',
        4: '交叉淘汰附加赛',
        5: '淘汰赛'
      },
      crossNumList: {
        2: '2'
      }
    };
  },
  filters: {
    dealAllowPlayOff(val) {
      console.log(
        "🚀 ~ file: query-view.vue:205 ~ dealAllowPlayOff ~ val",
        val
      );
      let allowPlayOffData = [
        { label: "无附加赛", value: 0 },
        { label: "第三四名争夺季军", value: 1 },
      ];
      return allowPlayOffData.find((item) => item.value == val).label || "";
    },
  },
  methods: {
    zfsuccess(data) {
      this.visibleFee = false;
      console.log(data, 789);
      if (data == 1) {
        // this.$showLoading()
        this.$http({
          url: this.$http.adornUrl(`/frFranchiseFeeRecord/checkPayStatus`),
          method: "post",
          data: {
            busId: this.ruleForm.id,
            busType: 1,
            busCategory: 2,
          },
        }).then((data) => {
          if (data && data.code === 0) {
            this.visible = false;
            //缴费成功，直接发布
            this.updateState(2);
          } else {
            this.$message.error(data.msg);
          }
        });
      }
    },
    init(id, type) {
      this.btnLoading = false
      this.title = "查看详情";
      this.ruleForm.id = id || null;
      this.visible = true;
      this.type = type;
      if (type === "release") {
        this.title = "审核发布";
        this.finachiseFeePay();
      }
      this.ruleForm.verifyReason = "";
      //回选
      if (this.ruleForm.id) {
        this.$http({
          url: this.$http.adornUrl(`/ctCompetition/getId/` + this.ruleForm.id),
          method: "get",
        }).then((data) => {
          if (data && data.code === 0) {
            this.pdfs = data.bean.attachmentsList;
            this.ruleForm = data.bean;
            this.ruleForm.ifDoublePoint =
              data.bean.competitionClub.ifDoublePoint;
            this.ruleForm.teamNum = data.bean.teamNum ? data.bean.teamNum : 16;
            if (this.ruleForm.competitionClub) {
              this.ruleForm.competitionClub.sixthMan = this.ruleForm
                .competitionClub.sixthMan
                ? 1
                : 0;
            } else {
              this.ruleForm.competitionClub = {
                sixthMan: -1,
              }; //默认是否第六人为1
            }
            this.listImageUrl = data.bean.imgUrlList;
            this.detailImageUrl = data.bean.imgUrlDetail;
            this.ruleForm.applyDate = [];
            this.ruleForm.applyDate.push(data.bean.matchSignStartTime);
            this.ruleForm.applyDate.push(data.bean.matchSignEndTime);
            this.ruleForm.ctRefundList = [];
            for (let i of data.eList) {
              for (let j of this.tableData) {
                j.price = i.price;
                break;
              }
            }
            this.ruleForm.verifyReason = "";
            if (data.bean.clubLimit) {
              this.ruleForm.clubLimit = data.bean.clubLimit.split(",");
              this.competitionRulesTab = this.ruleForm.clubLimit[0]
              if (data.bean.competitionMatchFormatGroupList && data.bean.competitionMatchFormatGroupList.length > 0) {
                const arr = []
                this.ruleForm.clubLimit.forEach(item => {
                  data.bean.competitionMatchFormatGroupList.forEach(one => {
                    if (Number(item) === one.groupCode) {
                      if (one.stage === 1) {
                        arr.push({
                          groupCode: one.groupCode,
                          groupName: one.groupName,
                          groupNickname: one.groupNickname,
                          teamNum: one.levelNum,
                          FirstCompetition: one.matchFormat,
                          groupNum: one.groupNum,
                          allowPlayOff: one.allowPlayOff,
                          groupRiseNum: one.groupRiseNum
                        })
                      }
                    }
                  })
                })
                data.bean.competitionMatchFormatGroupList.forEach(item => {
                  if (item.stage === 2) {
                    arr.forEach(one => {
                      if (item.groupCode === one.groupCode) {
                        one.SecondCompetition = item.matchFormat
                        one.crossNum = item.crossNum
                        one.allowPlayOff1 = item.allowPlayOff
                      }
                    })
                  }
                })
                this.competitionRules = arr
              } else {
                const arr = []
                Object.keys(this.competitionRulesTabList).forEach(item => {
                  if (this.ruleForm.clubLimit.includes(item)) {
                    arr.push({
                      groupCode: item,
                      groupName: this.competitionRulesTabList[item],
                      groupNickname: this.ruleForm.competitionMatchFormatList[0].groupNickname || '',
                      teamNum: this.ruleForm.teamNum || '',
                      FirstCompetition: this.ruleForm.competitionMatchFormatList[0].matchFormat || '',
                      groupNum: this.ruleForm.competitionMatchFormatList[0].groupNum || '',
                      allowPlayOff: this.ruleForm.competitionMatchFormatList[0].allowPlayOff || 0,
                      groupRiseNum: this.ruleForm.competitionMatchFormatList[0].groupRiseNum || '',
                      SecondCompetition: this.ruleForm.competitionMatchFormatList[1].matchFormat || '',
                      crossNum: this.ruleForm.competitionMatchFormatList[1].crossNum || '',
                      allowPlayOff1: this.ruleForm.competitionMatchFormatList[1].allowPlayOff || 0
                    })
                  }
                })
                this.competitionRules = arr
              }
            }
            let index = 1;
            for (let i of data.rList) {
              this.ruleForm.ctRefundList.push({
                index: index++,
                minDuration: i.minDuration,
                refundScale: i.refundScale,
              });
            }
          }
        });
      }
    },
    releaseSubmit(type) {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (type === 2) {
            this.$confirm("是否发布比赛?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(async () => {
                // 迭代三调试暂时关闭功能，直接打开下面注释即可

                // //查询是否需要预缴加盟费，需要则先交费，不需要则直接发布
                // //status状态(0未缴费，1已缴费，2已退费)
                // if (this.record.type === 1 && this.record.status === 0) {
                //   //仅未支付预缴费时，展示二维码支付页面
                //   this.visibleFee = true
                // } else {
                //   //不是预缴费，则直接发布
                //   this.updateState(type)
                // }
                // 迭代三调试暂时关闭功能，直接注释即可下面
                this.updateState(type);
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消发布",
                });
              });
          } else if (type === 5) {
            this.updateState(type);
          }
        }
      });
    },
    //查询是否需要预缴加盟费，需要则先交费，不需要则直接发布
    finachiseFeePay() {
      this.$http({
        url: this.$http.adornUrl(`/frFranchiseFeeRecord/createQrCode`),
        method: "post",
        data: {
          busId: this.ruleForm.id,
          busType: 1,
          busCategory: 2,
        },
      }).then((data) => {
        if (data && data.code === 0) {
          this.record = data.record;
          console.log("record", this.record);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    updateState(type) {
      this.btnLoading = true
      this.$http({
        url: this.$http.adornUrl(`/ctCompetition/updateStatus`),
        method: "post",
        params: this.$http.adornParams({
          status: type,
          id: this.ruleForm.id,
          verifyReason: this.ruleForm.verifyReason,
        }),
      }).then((data) => {
        if (data && data.code === 0) {
          this.$message({
            message: "审核成功",
            type: "success",
            duration: 1500,
            onClose: () => {
              this.visible = false;
              this.$emit("refreshDataList");
            },
          });
        } else {
          this.btnLoading = false
          this.$message.error(data.msg);
        }
      }).catch(() => {
        this.btnLoading = false
      })
    },
  },
};
</script>
<style >
.comecs .el-form-item__content {
  display: flex;
}
/* 比赛简介 */
p {
  margin: 0;
}
</style>
